export default {"src":"/_next/static/image/public/images/CaretDown.0ad173ea17e27e1ee6d61be01643c3c9.svg","height":24,"width":25};